import React from 'react';
import { useInView } from 'react-intersection-observer';
import './Abouts.css';
import aboutImage from '../../img/environment/forest.jpg'; // Make sure this path is correct

const Abouts = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="about-section" ref={ref}>
      <div className="container">
        <div className={`about-content ${inView ? 'animate' : ''}`}>
          <div className="about-text">
            <h2 className="section-title">Why Work with Us</h2>
            <div className="underline"></div>
            <p>
              ED&P Ltd is a local multi-disciplinary environmental consultancy firm headquartered in Kigali, Rwanda. The firm has been involved in providing Environmental assessment, institutional assessment, Training and Capacity Building in EIA.
            </p>
            <a href="http://ecodesignprotect.com/about-us-2/" className="learn-more-btn">
              Learn More
              <span className="btn-shine"></span>
            </a>
          </div>
          <div className="about-image">
            <div className="image-container">
              <img src={aboutImage} alt="Sunlight through woodland, illustrating ecosystem conservation" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Abouts;